module.exports = __webpack_public_path__ + "static/media/wallet-connected.976540d1.svg";